<template>
  <div
    style="background-color: #fff;"
    class="alert-hint"
    :style="{ 'max-width': maxWidth + 'px' }"
  >
    <v-alert
      :outlined="outlined"
      color="primary"
      class="ma-0 alert-hint"
      dense
      dark
      :rounded="rounded"
      :icon="icon"
      type="warning"
    >
      <span v-html="hint" class="hint-text"></span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: "InfoAlert",
  props: {
    hint: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "lg"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    iconMdi: {
      default: false
    },
    iconDefault: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: "1000"
    }
  },
  computed: {
    icon() {
      return this.iconDefault ? "mdi-help-circle-outline" : this.iconMdi;
    }
  }
};
</script>

<style lang="scss">
.alert-hint {
  .hint-text {
    font-size: 0.875rem;
  }

  .v-icon {
    color: var(--c-yellow);
  }
}
</style>
